
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Api_Endpoints } from '../../Api/apiEndpoint';
import { makeApiCall } from '../../Api/makeApiCall';
// import Dropdown from '../../components/UI/Dropdown';
import Dropdown from '../../components/ui/Dropdown'
import TextInput from '../../components/ui/TextInput';
import { CloseIcon, Downloadpdf, EditIcon, ViewIcon } from '../../Constant/ImageConstant';
import { showErrorToast, showSuccessToast } from '../../utils/toastService';
import './VendorViewPage.css';
import ImageModal from './ImageModal';
import DatePicker from '../../components/ui/CustomDatePicker';
import FileUpload from '../../components/ui/CustomFileUpload';

export const VendorViewPage = () => {
  const data = useLocation()
  const navigate = useNavigate()
  const [date, setDate] = useState('');
  const [error, setError] = useState('');

  const VendorID = data?.state?.VendorID
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');


  const [VendorDropdown, setVendorDropDown] = useState({})
  const [InvoiceDropDown, setInvoiceDropDown] = useState({})

  // Add loading state for save operations
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    // gst_type: '',
    // tds_type: "",
    name: '',
    email: '',
    authorized_signatory_email: '',
    mobile_no: '',
    authorized_signatory_mobile_no: '',
    pan_no: '',
    cin_no: '',
    gst_no: '',
    address: '',
    account_no: '',
    ifsc_code: '',
    account_holder_name: '',
    nature_of_business: '',
    agreement_status: '',
    agreement_type: '',
    agreement_type: '',
    state: '',
    city: '',
    authorized_signatory: '',
    address_proof_type: "",
    upload_address_proof: "",

    upload_cin_no: "",
    upload_cancelled_bank: "",
    gst_rate: "",
    tds_rate: "",
    tds_type: "",
    gst_type: "",
    pincode: "",
    payment_term: "",
    //vendor_category: "",
    vendor_referral_code: "",
    vendor_category_id: "",
    upload_moa_form: "",
    upload_aoa_form: "",
    upload_pan_no: "",
    upload_gst_certificate: "",
    upload_agreement: "",
    agreement_start_date: "",
    agreement_end_date: "",
    vendor_type: "",
    remark_first: "",
    remark_sec: "",
    is_draft: false,

  });
  const [formErrors, setFormErrors] = useState({});

  const fetchPincode = async (pincode) => {
    const res = await makeApiCall(Api_Endpoints.PINCODE, "POST", { pincode: pincode })
    if (res?.status) {

      setFormData({ ...formData, pincode: pincode, state: res.result.state_name, city: res.result.city_or_village_name })
      setFormErrors({ ...formErrors, pincode: "", state: "", city: "" })


    } else {
      setFormData({ ...formData, state: "", city: "" })


    }
  }


  const handleChange = (e, field) => {
    const { value } = e.target;
    let errors = { ...formErrors };
    delete errors[field]
    switch (field) {
      case 'email': {
        if (value && !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(value)) {
          errors.email = 'Invalid email format';
        } else {
          delete errors.email;
        }
        setFormData({ ...formData, [field]: value });
        break;
      }
      case 'authorized_signatory_email': {
        if (value && !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(value)) {
          errors.authorized_signatory_email = 'Invalid email format';
        } else {
          delete errors.authorized_signatory_email;
        }
        setFormData({ ...formData, [field]: value });
        break;
      }
      case 'pincode': {
        if (value.length === 6) {
          fetchPincode(value);
        }
        setFormData({ ...formData, [field]: value });
        break;
      }

      case 'mobileNumber': {
        if (value && !/^\d{10}$/.test(value)) {
          errors.mobileNumber = 'Mobile number should be 10 digits';
        } else {
          delete errors.mobileNumber;
        }
        setFormData({ ...formData, [field]: value });
        break;
      }
      case 'authorized_signatory_mobile_no': {
        if (value && !/^\d{10}$/.test(value)) {
          errors.authorized_signatory_mobile_no = 'Mobile number should be 10 digits';
        } else {
          delete errors.authorized_signatory_mobile_no;
        }
        setFormData({ ...formData, [field]: value });
        break;
      }
      case 'gstNumber': {
        if (value) {
          const gstValue = value.toUpperCase();
          // Basic GST format: 2 numbers + PAN + 1 letter + Z + 1 character
          const gstFormat = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][A-Z0-9]Z[A-Z0-9]$/;

          if (!gstFormat.test(gstValue)) {
            errors.gstNumber = 'Invalid GST number format';
          } else {
            // Extract PAN portion from GST (characters 3-12)
            const panFromGST = gstValue.substring(2, 12);
            const existingPAN = formData.pan_no ? formData.pan_no.toUpperCase() : '';

            if (existingPAN && existingPAN !== '') {
              // Compare with existing PAN
              if (panFromGST !== existingPAN) {
                errors.gstNumber = `GST number must contain PAN number ${existingPAN} (currently contains ${panFromGST})`;
              } else {
                delete errors.gstNumber;
              }
            } else {
              delete errors.gstNumber;
            }
          }
          setFormData({ ...formData, [field]: gstValue });
        } else {
          delete errors.gstNumber;
          setFormData({ ...formData, [field]: value });
        }
        break;
      }

      case 'account_no': {
        if (value) {
          if (!/^\d{9,18}$/.test(value)) {
            errors.account_no = 'Account Number must be 09 to 18 digits long and contain only numbers';
          } else {
            delete errors.account_no;
          }
        } else {
          delete errors.account_no;
        }
        setFormData({ ...formData, [field]: value });
        break;
      }

      case 'ifsc_code': {
        const ifscValue = value.toUpperCase();
        if (ifscValue && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifscValue)) {
          errors.ifsc_code = 'Invalid IFSC Code format (e.g., ABCD0123456)';
        } else {
          delete errors.ifsc_code;
        }
        setFormData({ ...formData, [field]: ifscValue });
        break;
      }

      case 'pan_no': {
        if (value) {
          const panValue = value.toUpperCase();
          const panFormat = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

          if (!panFormat.test(panValue)) {
            errors.pan_no = 'Invalid PAN number format (e.g., ABCDE1234F)';
          } else {
            delete errors.pan_no;

            // Check if GST exists and validate against new PAN
            const existingGST = formData.gstNumber ? formData.gstNumber.toUpperCase() : '';
            if (existingGST && existingGST !== '') {
              const panFromGST = existingGST.substring(2, 12);
              if (panFromGST !== panValue) {
                errors.gstNumber = `GST number must contain PAN number ${panValue} (currently contains ${panFromGST})`;
              } else {
                delete errors.gstNumber;
              }
            }
          }
          setFormData({ ...formData, [field]: panValue });
        } else {
          delete errors.pan_no;
          setFormData({ ...formData, [field]: value });
        }
        break;
      }

      default: {
        setFormData({ ...formData, [field]: value });
        break;
      }
    }

    setFormErrors(errors);
  };

  function getLableFromID(dropdownArray, label) {
    // Find the item in the dropdown array that matches the given label

    const item = dropdownArray?.find(option => option.value === label);
    // Return the value (id) if the item is found, else return null or an appropriate message
    return item ? item.label : null;
  }

// Updated function to handle saving draft with clean payload
const handleSaveDraft = async (e) => {
  e.preventDefault();
  setIsSaving(true);
  
  try {
    // Start with basic required fields
    let payload = {
      is_draft: true // Mark as draft
    };

    // Add vendor_id for update operations
    if (VendorID) {
      payload.vendor_id = VendorID;
    }

    // Helper function to add field only if it has a valid value
    const addFieldIfValid = (fieldName, value) => {
      if (value !== null && value !== undefined && value !== '' && value !== 0) {
        payload[fieldName] = value;
      }
    };

    // Add all form fields only if they have valid values
    Object.keys(formData).forEach(key => {
      // Skip the is_draft field as we're setting it explicitly
      if (key !== 'is_draft') {
        addFieldIfValid(key, formData[key]);
      }
    });

    // Handle comments for draft
    if (comments && comments.length > 0) {
      addFieldIfValid('remark_first', comments[0]?.text);
      if (comments.length > 1) {
        addFieldIfValid('remark_sec', comments[1]?.text);
      }
    }

    // Handle file fields for draft
    const fileFields = [
      'upload_address_proof',
      'upload_agreement',
      'upload_aoa_form',
      'upload_cancelled_bank',
      'upload_cin_no',
      'upload_gst_certificate',
      'upload_moa_form',
      'upload_pan_no'
    ];

    fileFields.forEach(field => {
      if (formData[field] && formData[field].isExistingFile) {
        // For existing files, add the URL field
        addFieldIfValid(`url_${field}`, formData[field].url);
        // Don't add the upload field itself for existing files
      } else if (formData[field] && formData[field] instanceof File) {
        // For new file uploads
        payload[field] = formData[field];
      }
    });

    // Add vendor category if available
    if (VendorDropdown.vendor_category && formData.vendor_category_id) {
      const vendorCategoryLabel = getLableFromID(VendorDropdown.vendor_category, formData.vendor_category_id);
      if (vendorCategoryLabel) {
        payload.vendor_category = vendorCategoryLabel;
      }
    }

    // Final cleanup - ensure no null or undefined values
    const cleanPayload = {};
    Object.keys(payload).forEach(key => {
      const value = payload[key];
      if (value !== null && value !== undefined) {
        cleanPayload[key] = value;
      }
    });

    console.log("Clean draft payload (no nulls/empty values):", cleanPayload);

    // Make API call to save draft
    const res = await makeApiCall(
      Api_Endpoints.VENDOR_SAVE_DRAFT || Api_Endpoints.VENDOR_ADD,
      "POST",
      cleanPayload
    );

    if (res.status) {
      navigate('/draftVendorList');
      showSuccessToast("Draft saved successfully!");
    } else {
      showErrorToast(res?.message || "Failed to save draft");
    }
  } catch (error) {
    console.error("Error saving draft:", error);
    showErrorToast("An error occurred while saving draft");
  } finally {
    setIsSaving(false);
  }
};

  const handleSubmit = async (e) => {
    console.log(formData, "FormData");
    e.preventDefault();
    setIsSubmitting(true);

    // First, determine if this is an update based on VendorID
    const isUpdate = VendorID ? true : false;
    console.log("Is update operation:", isUpdate);

    let errors = {};

    // Skip validation for certain fields if this is an update
    if (!isUpdate) {
      // Basic validation for required fields (only for new entries)
      Object.keys(formData).forEach((key) => {
        if (formData[key] === '' &&
          key !== 'cin_no' &&
          key !== 'gst_no' &&
          key !== 'upload_cin_no' &&
          key !== "authorized_signatory_mobile_no" &&
          key !== "authorized_signatory_email" &&
          key !== "url_upload_agreement" &&
          key !== 'upload_moa_form' &&
          key !== 'upload_aoa_form') {
          errors[key] = 'This field is required';
        }
      });
    }

    // Rest of your validation logic as before...
    // Conditional validation
    if (formData.gst_type === 'ELIGIBLE' && !isUpdate) {
      if (!formData.gst_rate) {
        errors.gst_rate = 'GST Rate is required';
      }
      if (!formData.upload_gst_certificate) {
        errors.upload_gst_certificate = 'GST Certificate is required';
      }
    } else {
      delete errors.gst_rate;
      delete errors.upload_gst_certificate;



    }

    if (formData.tds_type === 'ELIGIBLE') {
      if (!formData.tds_rate) {
        errors.tds_rate = 'TDS Rate is required';
      }
    }
    else {
      delete errors.tds_rate;


    }

    if (formData.cin_no && !isUpdate) {
      // Check if CIN is valid
      const cinRegex = /^[LU][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/;

      if (!cinRegex.test(formData.cin_no)) {
        errors.cin_no = 'Invalid CIN format';
      }

      // Check if the CIN document is uploaded

    } else {
      delete errors.upload_cin_no;
      delete errors.cin_no;


    }
    if (!formData.pan_no && !isUpdate) {
      // PAN validation regex
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

      if (!panRegex.test(formData.pan_no)) {
        errors.pan_no = 'Invalid PAN format';
      }

      // Check if the PAN document is uploaded
      // if (!formData.upload_pan_no) {
      //   errors.upload_pan_no = 'PAN Document is required';
      // }
    } else {
      // Remove errors if pan_no is not provided
      delete errors.pan_no;
      // delete errors.upload_pan_no;
    }
    if (!formData.upload_pan_no) {
      errors.upload_pan_no = 'PAN Document is required';
    } else {
      delete errors.upload_pan_no;
    }


    if (formData.agreement_status === 'Yes') {
      if (formData.agreement_type === 'Periodic Agreement') {
        // Mandatory checks for Periodic Agreement
        if (!formData.agreement_start_date) {
          errors.agreement_start_date = 'Agreement Start Date is required';
        }
        if (!formData.agreement_end_date) {
          errors.agreement_end_date = 'Agreement End Date is required';
        }
        if (!formData.upload_agreement) {
          errors.upload_agreement = 'Agreement Document is required';
        }

        // Remove mandatory checks for remarks
        delete errors.remark_first;
        delete errors.remark_sec;

      } else if (formData.agreement_type === 'Open Agreement') {
        // Mandatory checks for Open Agreement
        if (!formData.agreement_start_date) {
          errors.agreement_start_date = 'Agreement Start Date is required';
        }
        if (!formData.upload_agreement) {
          errors.upload_agreement = 'Agreement Document is required';
        }
        delete errors.agreement_end_date;

        // Remove mandatory checks for remarks
        delete errors.remark_first;
        delete errors.remark_sec;
      }
    } else {
      // When agreement status is not 'Yes', remove all related errors
      delete errors.agreement_start_date;
      delete errors.agreement_end_date;
      delete errors.upload_agreement;
      delete errors.agreement_type;
      delete errors.remark_first;
      delete errors.remark_sec;
    }


    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      console.log(errors, '>>>>>>>>kjhgv');
      const errorFields = Object.keys(errors).join(', ');
      showErrorToast(`Please fill the following mandatory fields: ${errorFields}`);
      setIsSubmitting(false);
      // showErrorToast('Fill Mandatory Fielhgfds');
      return; // Stop execution if there are errors
    }
    try {
      // Create the payload based on the original form data
      let payload = { ...formData };

      if (comments && comments.length > 0) {
        // First comment exists, set remark_first
        payload.remark_first = comments[0] && comments[0].text ? comments[0].text : '';

        // Check if second comment exists, set remark_sec
        if (comments.length > 1 && comments[1] && comments[1].text) {
          payload.remark_sec = comments[1].text;
        } else {
          payload.remark_sec = '';
        }
      } else {
        // No comments, set both remarks to empty strings
        payload.remark_first = '';
        payload.remark_sec = '';
      }

      console.log("Payload with remarks:", payload);

      const fileFields = [
        'upload_address_proof',
        'upload_agreement',
        'upload_aoa_form',
        'upload_cancelled_bank',
        'upload_cin_no',
        'upload_gst_certificate',
        'upload_moa_form',
        'upload_pan_no'
      ];

      // For each file field, check if it's an existing file object
      fileFields.forEach(field => {
        if (payload[field] && payload[field].isExistingFile) {
          // For existing files, preserve the URL in the corresponding url_ field
          payload[`url_${field}`] = payload[field].url;

          // Clear the upload field since we're not uploading a new file
          payload[field] = '';
        }
        // For new files, they'll be properly handled by your API
      });
      // If this is an update operation
      if (isUpdate) {
        // Add vendor_id to the payload for update operations
        payload.vendor_id = VendorID;

        // Handle URL fields specifically for updates
        const urlFields = [
          'url_upload_address_proof',
          'url_upload_agreement',
          'url_upload_aoa_form',
          'url_upload_cancelled_bank',
          'url_upload_cin_no',
          'url_upload_gst_certificate',
          'url_upload_moa_form',
          'url_upload_pan_no',
          'agreement_end_date',
          'agreement_start_date',
          'upload_agreement',
          'upload_gst_certificate',
          'upload_aoa_form',
          'upload_moa_form',
          'upload_cin_no',
          'gst_no',
          'cin_no',
          'upload_address_proof',
          'upload_pan_no',
          'upload_cancelled_bank'
        ];

        // For each URL field, ensure it's an empty string if not provided
        urlFields.forEach(field => {
          // If the field doesn't exist in the payload or is null, set to empty string
          if (payload[field] === undefined || payload[field] === null) {
            payload[field] = '';
          }
        });
      }

      // Add the vendor category
      if (VendorDropdown.vendor_category && payload.vendor_category_id) {
        payload.vendor_category = getLableFromID(VendorDropdown.vendor_category, payload.vendor_category_id);
      }

      console.log("Final payload:", payload);

      // Make the API call
      const res = await makeApiCall(
        isUpdate ? Api_Endpoints.VENDOR_ADD : Api_Endpoints.VENDOR_ADD,
        "POST",
        payload
      );

      console.log("API response:", res);

      if (res.status) {
        navigate('/Vendors');
        showSuccessToast(res?.message);
      } else {
        showErrorToast(res?.message || "An error occurred");
        console.error("API error:", res);
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      showErrorToast("An unexpected error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };


  const [details, setDetails] = useState([])
  // const getVendorData = async () => {
  //  let seaechEndpoint   =  true?Api_Endpoints.VENDOR_SAVE_DRAFT_DETAILS:Api_Endpoints.VENDOR_DETAILS
  //   const response = await makeApiCall(seaechEndpoint, 'POST', { vendor_id: VendorID });
  //   if (response?.status) {

  //     setDetails(response.result.vendor_details)
  //     // setFormData({ ...response.result.vendor_details,vendor_type:getLableFromID(VendorDropdown?.vendor_type,response.result.vendor_details?.vendor_type,) })
  //     setFormData({ ...response.result.vendor_details })

  //   } else {
  //     showErrorToast(response?.message)
  //   }
  // };
  const getVendorData = async () => {
    // Check if the state contains draft information
    const isDraft = data?.state?.isDraft || data?.state?.type === 'draft';
    
    let searchEndpoint = isDraft 
      ? Api_Endpoints.VENDOR_SAVE_DRAFT_DETAILS 
      : Api_Endpoints.VENDOR_DETAILS;
      
    const response = await makeApiCall(searchEndpoint, 'POST', { vendor_id: VendorID });
    if (response?.status) {
      setDetails(response.result.vendor_details);
      setFormData({ ...response.result.vendor_details });
    } else {
      showErrorToast(response?.message);
    }
  };


  const getVendorDropDown = async (
  ) => {
    const res = await makeApiCall(Api_Endpoints.DASHBOARD_DROPDOWN, "GET",)
    if (res?.status) {
      setVendorDropDown(res?.data.vendor)
      setInvoiceDropDown(res?.data.invoice)
    }
  }

  //statusFilter.vendor_filter
  const handleAddComment = (e) => {
    e.preventDefault();
    if (newComment.trim() && comments.length < 2) {
      setComments([
        ...comments,
        {
          id: Date.now(),
          text: newComment
        }
      ]);
      setNewComment('');
    }
  };

  const handleRemoveComment = (id) => {
    setComments(comments.filter(comment => comment.id !== id));
  };

  const [file, setFile] = useState(null);

  const handleFileChange = (e, field) => {
    if (e && e.isExistingFile) {
      // For existing files, store the special object which includes the URL
      setFormData({ ...formData, [field]: e });
      setFormErrors({ ...formErrors, [field]: "" });
      return;
    }
    const selectedFile = e;
    console.log(e, selectedFile, "THIS IS FILE SELECTED")

    if (selectedFile) {
      setFormData({ ...formData, [field]: selectedFile });
    } else {
      // If file was cleared
      setFormData({ ...formData, [field]: null });
    }

    setError('');
    setFormErrors({ ...formErrors, [field]: "" });

  };

  const handleDropDownChange = (e, field) => {
    // Create a copy of the current form data
    let updatedFormData = { ...formData };

    switch (field) {
      case 'tds_type':
        // If tds_type is changed to NON ELIGIBLE, clear the tds_rate
        if (e.target.value === 'NON ELIGIBLE') {
          updatedFormData = {
            ...updatedFormData,
            tds_type: e.target.value,
            tds_rate: '' // Clear the tds_rate
          };
        } else {
          updatedFormData[field] = e.target.value;
        }
        break;
      case 'gst_type':
        // If gst_type is changed to NON ELIGIBLE, clear the tds_rate
        if (e.target.value === 'NON ELIGIBLE') {
          updatedFormData = {
            ...updatedFormData,
            gst_type: e.target.value,
            gst_rate: '', // Clear the tds_rate
          };
        } else {
          updatedFormData[field] = e.target.value;
        }
        break;

      case 'agreement_status':
        // If agreement_status is changed to No, clear all agreement related fields
        if (e.target.value === 'No') {
          updatedFormData = {
            ...updatedFormData,
            agreement_status: e.target.value,
            agreement_type: '',
            agreement_start_date: '',
            agreement_end_date: '',
            upload_agreement: ''
          };
        } else {
          updatedFormData[field] = e.target.value;
        }
        break;

      default:
        // For all other fields, just update normally
        updatedFormData[field] = e.target.value;
    }

    // Update form data
    setFormData(updatedFormData);

    // Clear any errors for the changed field and related fields
    if (field === 'agreement_status' && e.target.value === 'No') {
      setFormErrors({
        ...formErrors,
        agreement_status: '',
        agreement_type: '',
        agreement_start_date: '',
        agreement_end_date: '',
        upload_agreement: ''
      });
    } else {
      setFormErrors({ ...formErrors, [field]: '' });
    }
  };

  const handleDateChange = (e, field) => {
    setDate(e.target.value);
    setFormData({ ...formData, [field]: e.target.value })
    setFormErrors({ ...formErrors, [field]: "" })
  };

  const [isUpdate, setIsUpdate] = useState(false)

  useEffect(() => {
    if (VendorID) {
      getVendorData();
      setIsUpdate(true)
    } else {
      // Initialize with empty data for new vendor
      setFormData({ ...formData, remark_first: "", remark_sec: "" });
    }
    getVendorDropDown()
  }, [])
  useEffect(() => {
    // When form data changes, initialize comments from remark fields
    const commentsArray = [];

    if (formData.remark_first) {
      commentsArray.push({
        id: 1,
        text: formData.remark_first
      });
    }

    if (formData.remark_sec) {
      commentsArray.push({
        id: 2,
        text: formData.remark_sec
      });
    }

    if (commentsArray.length > 0) {
      setComments(commentsArray);
    }
  }, [formData.remark_first, formData.remark_sec]);
  useEffect(() => { }, [VendorDropdown])
  return (

    <div className='VendorViewContainer'>


      <div className='VendorForm'>
        <form onSubmit={handleSubmit}>
          <div className='details-bifurcation-card'>
            <h3> Vendor Details</h3>

            <div className='TextInputRow'>
              <TextInput
                label="Vendor Name"
                name="name"
                required={true}
                value={formData.name}
                onChange={(e) => handleChange(e, 'name')}
                placeholder="Enter Vendor Name"
                error={formErrors.name}
                isDisabled={false}
                caseType="uppercase"
                fieldType="alphabet"
              />

              <TextInput
                label="Vendor Mobile Number"
                name="mobile_no"
                required={true}
                value={formData.mobile_no}
                onChange={(e) => handleChange(e, 'mobile_no')}
                placeholder="Enter Mobile Number"
                error={formErrors.mobile_no}
                isDisabled={false}
                fieldType={'number'}
                maxLength={10}
              />

              <TextInput
                label="Vendor Email ID"
                name="email"
                required={true}
                value={formData.email}
                onChange={(e) => handleChange(e, 'email')}
                placeholder="Enter Email"
                error={formErrors.email}
                isDisabled={false}
                fieldType="email"
              />

            </div>


            <div className='TextInputRow'>


              <TextInput
                label="Nature of Business"
                name="nature_of_business"
                required={true}
                value={formData.nature_of_business}
                onChange={(e) => handleChange(e, 'nature_of_business')}
                placeholder="Enter Nature of Business"
                error={formErrors.nature_of_business}
                isDisabled={false}
                fieldType="alphanumeric"
                caseType={'uppercase'}
              />

              <TextInput
                label="Vendor Address"
                name="address"
                required={true}
                value={formData.address}
                onChange={(e) => handleChange(e, 'address')}
                placeholder="Enter Vendor Address"
                error={formErrors.address}
                isDisabled={false}
                caseType={'uppercase'}
              />

            </div>
            <div className='TextInputRow'>


              <TextInput
                label="Pincode"
                name="pincode"
                required={true}
                value={formData.pincode}
                onChange={(e) => handleChange(e, 'pincode')}
                placeholder="Enter Pincode"
                error={formErrors.pincode}
                isDisabled={false}
                fieldType={'number'}
                maxLength={6}
              />
              <TextInput
                label="State"
                name="state"
                required={true}
                value={formData.state}
                onChange={(e) => handleChange(e, 'state')}
                placeholder="Enter State"
                error={formErrors.state}
                isDisabled={true}
                fieldType={'alphabet'}
                caseType={'uppercase'}
              />

              <TextInput
                label="City"
                name="city"
                required={true}
                value={formData.city}
                onChange={(e) => handleChange(e, 'city')}
                placeholder="Enter City"
                error={formErrors.city}
                isDisabled={true}
                fieldType={'alphabet'}
                caseType={'uppercase'}
              />
            </div>
          </div>
          <div className='details-bifurcation-card'>
            <h3> Authorized Signatory Details</h3>
            <div className='TextInputRow'>
              <TextInput
                label="Authorized Signatory Name"
                name="authorized_signatory"
                required={true}
                value={formData.authorized_signatory}
                onChange={(e) => handleChange(e, 'authorized_signatory')}
                placeholder="Enter Authorized Signatory"
                error={formErrors.authorized_signatory}
                isDisabled={false}
                caseType={'uppercase'}
                fieldType={'alphabet'}
              />
              <TextInput
                label="Authorized Signatory Mobile Number"
                name="authorized_signatory_mobile_no"

                value={formData.authorized_signatory_mobile_no}
                onChange={(e) => handleChange(e, 'authorized_signatory_mobile_no')}
                placeholder="Enter Mobile Number"
                error={formErrors.authorized_signatory_mobile_no}
                isDisabled={false}
                fieldType={'number'}
                maxLength={10}
              />

              <TextInput
                label="Authorized Signatory Email ID"
                name="authorized_signatory_email"
                required={false}
                value={formData.authorized_signatory_email}
                onChange={(e) => handleChange(e, 'authorized_signatory_email')}
                placeholder="Enter Authorized Signatory Email"
                error={formErrors.authorized_signatory_email}
                isDisabled={false}
                fieldType="email"
              />
            </div>
          </div>

          <div className='details-bifurcation-card'>
            <h3> Vendor Bank Details</h3>
            <div className='TextInputRow'>
              <TextInput
                label="Account Number"
                name="account_no"
                required={true}
                value={formData.account_no}
                onChange={(e) => handleChange(e, 'account_no')}
                placeholder="Enter Account Number"
                error={formErrors.account_no}
                isDisabled={false}
                fieldType="number"
                caseType={'uppercase'}
                maxLength={18}
              />
              <TextInput
                label="Account Holder Name"
                name="account_holder_name"
                required={true}
                value={formData.account_holder_name}
                onChange={(e) => handleChange(e, 'account_holder_name')}
                placeholder="Enter Account Holder Name"
                error={formErrors.account_holder_name}
                isDisabled={false}
                caseType={'uppercase'}
                fieldType={'alphabet'}
              />
              <TextInput
                label="IFSC Code"
                name="ifscCode"
                required={true}
                value={formData.ifsc_code}
                onChange={(e) => handleChange(e, 'ifsc_code')}
                placeholder="Enter IFSC Code"
                error={formErrors.ifsc_code}
                isDisabled={false}
                fieldType="ifsc"

                caseType="uppercase"

                maxLength={11}
              />
            </div>
          </div>

          <div className='details-bifurcation-card'>
            <h3> Vendor Classification</h3>
            <div className='TextInputRow'>


              <Dropdown
                onChange={(e) => handleDropDownChange(e, "vendor_type")}
                options={VendorDropdown.vendor_type}
                value={formData?.vendor_type}

                placeholder={'Select  Vendor Type'}
                inputClassName={'bankDropDown'}
                label='Vendor Type'
                error={formErrors.vendor_type}
                required={true}
              />


              <Dropdown
                onChange={(e) => handleDropDownChange(e, "vendor_category_id")}
                options={VendorDropdown.vendor_category}
                value={formData?.vendor_category_id}
                placeholder={'Select Vendor Category'}
                inputClassName={'bankDropDown'}
                error={formErrors.vendor_category_id}

                label='Vendor Categories'
                required={true}
              />
              <Dropdown
                onChange={(e) => handleDropDownChange(e, "payment_term")}
                options={InvoiceDropDown.payment_time}
                error={formErrors.payment_term}
                value={formData?.payment_term}
                placeholder={'Select Payment Terms'}
                inputClassName={'bankDropDown'}
                label='Payment Term'
                required={true}
              />

            </div>
            <div className='TextInputRow'>

              <TextInput
                label="Vendor Referral Name/ IIL Code"
                name="vendorReferralCode"
                required={true}
                value={formData.vendor_referral_code}
                onChange={(e) => handleChange(e, 'vendor_referral_code')}
                placeholder="Enter Vendor Referral Code"
                error={formErrors.vendor_referral_code}
                isDisabled={false}
              />


              {console.log(formData.agreement_status, "agreementstatus")}
              <Dropdown
                onChange={(e) => handleDropDownChange(e, "agreement_status")}
                options={VendorDropdown.agreement_status}
                error={formErrors.agreement_status}
                value={formData?.agreement_status}
                placeholder={'Select Agreement Status'}
                inputClassName={'bankDropDown'}
                label='Select Agreement Status'
                required={true}
              />
              {formData.agreement_status === 'Yes' && (
                <Dropdown
                  onChange={(e) => handleDropDownChange(e, "agreement_type")}
                  options={VendorDropdown.agreement_type}
                  error={formErrors.agreement_type}
                  value={formData?.agreement_type}
                  placeholder={'Select Agreement Types'}
                  inputClassName={'bankDropDown'}
                  label='Select Agreement Types'
                  required={true}
                />)}
            </div>
            <div className='TextInputRow'>

              {formData.agreement_status === 'Yes' && (
                <>


                  <div className='TextInputRow'>
                    {(formData.agreement_type === 'Periodic Agreement' ||
                      formData.agreement_type === 'Open Agreement') && (
                        <DatePicker
                          label="Agreement Start Date"
                          value={formData.agreement_start_date}
                          onChange={(e) => handleDateChange(e, 'agreement_start_date')}
                          error={formErrors.agreement_start_date}
                          required={true}
                          isDisabled={false}
                        />
                      )}

                    {formData.agreement_type === 'Periodic Agreement' && (
                      <DatePicker
                        value={formData.agreement_end_date}
                        label="Agreement End Date"
                        onChange={(e) => handleDateChange(e, 'agreement_end_date')}
                        error={formErrors.agreement_end_date}
                        required={true}
                        isDisabled={false}
                      />
                    )}

                    <FileUpload
                      label="Upload Agreement"
                      onChange={(e) => handleFileChange(e, 'upload_agreement')}
                      value={details.url_upload_agreement || ""}
                      required={true}
                      accept=".jpg, .jpeg, .png, .pdf"
                      multiple={false}
                      note="Only PDF, JPG, JPEG, and PNG files are allowed."
                    // inputClassName={details.upload_agreement}
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          <div className='details-bifurcation-card'>
            <h3> Vendor Compliances</h3>
            <div className='TextInputRow'>
              <Dropdown
                onChange={(e) => handleDropDownChange(e, "tds_type")}
                options={VendorDropdown.tds_type}
                error={formErrors.tds_type}
                value={formData.tds_type}
                placeholder={'Select TDS Type'}
                inputClassName={'bankDropDown'}
                label='TDS Type'
                required={true}
              />
              <Dropdown
                onChange={(e) => handleDropDownChange(e, "tds_rate")}
                options={VendorDropdown.tds_rate}
                error={formErrors.tds_rate}
                isDisabled={formData.tds_type !== "ELIGIBLE"}
                value={formData.tds_rate}
                placeholder={'Select TDS Rate'}
                inputClassName={'bankDropDown'}
                label='TDS Rate'
                required={formData.tds_type === "ELIGIBLE" ? true : false}
              />

            </div>
            <div className='TextInputRow'>
              <Dropdown
                onChange={(e) => handleDropDownChange(e, "gst_type")}
                options={VendorDropdown.gst_type}
                error={formErrors.gst_type}
                value={formData?.gst_type}
                placeholder={'Select GST Type'}
                inputClassName={'bankDropDown'}
                label='GST Type'
                required={true}
              />
              <Dropdown
                onChange={(e) => handleDropDownChange(e, "gst_rate")}
                options={VendorDropdown.gst_rate}
                error={formErrors.gst_rate}
                isDisabled={formData.gst_type !== "ELIGIBLE" ? true : false}
                required={formData.gst_type === "ELIGIBLE" ? true : false}
                value={formData.gst_rate}
                placeholder={'Select GST Rate'}
                inputClassName={'bankDropDown'}
                label='GST Rate'
              />
            </div>

          </div>

          <div className='details-bifurcation-card'>

            <h3>Documents Upload </h3>

            <div className='TextInputRow upload_Cheque'>
              <FileUpload
                label="Upload Cancelled Cheque Document"
                onChange={(e) => handleFileChange(e, 'upload_cancelled_bank')}
                value={details.url_upload_cancelled_bank || ""}
                error={formErrors.upload_cancelled_bank}
                required={true}
                accept=".jpg, .jpeg, .png, .pdf"
                multiple={false}
                note="Only PDF, JPG, JPEG, and PNG files are allowed."
              // inputClassName={details.url_upload_cancelled_bank}
              />


            </div>

            <div className='TextInputRow'>
              <Dropdown
                onChange={(e) => handleDropDownChange(e, "address_proof_type")}
                options={VendorDropdown.address_proof_type}
                error={formErrors.address_proof_type}
                value={formData.address_proof_type}
                placeholder={'Select Address Proof'}
                inputClassName={'bankDropDown'}
                label='Address Proof'
                required={true}
              />

              <FileUpload
                label="Upload Address File"
                onChange={(e) => handleFileChange(e, 'upload_address_proof')}
                error={formErrors.upload_address_proof}
                value={details.url_upload_address_proof || ""}
                required={true}
                accept=".jpg, .jpeg, .png, .pdf"
                multiple={false}
                note="Only PDF, JPG, JPEG, and PNG files are allowed."
              />


            </div>


            <div className='TextInputRow'>
              <TextInput
                label="PAN Number"
                name="pan_no"
                required={true}
                value={formData.pan_no}
                onChange={(e) => handleChange(e, 'pan_no')}
                placeholder="Enter PAN Number"
                error={formErrors.pan_no}

                isDisabled={false}
                fieldType="pan"
                caseType={'uppercase'}

                maxLength={10}
              />
              <FileUpload
                label="Upload Pan Document"
                onChange={(e) => handleFileChange(e, 'upload_pan_no')}
                value={details.url_upload_pan_no || ""}
                error={formErrors.upload_pan_no}
                required={true}
                accept=".jpg, .jpeg, .png, .pdf"
                multiple={false}
                note="Only PDF, JPG, JPEG, and PNG files are allowed."
              />

            </div>


            <div className='TextInputRow'>
              <TextInput
                label="CIN Number"
                name="cin_no"
                value={formData.cin_no}
                onChange={(e) => handleChange(e, 'cin_no')}
                placeholder="Enter CIN Number"
                error={formErrors.cin_no}
                isDisabled={false}
                fieldType="alphanumeric"
                caseType={'uppercase'}
              />

              <FileUpload
                label="Upload CIN Document"
                onChange={(e) => handleFileChange(e, 'upload_cin_no')}
                value={details.url_upload_cin_no || ""}
                required={false}
                accept=".jpg, .jpeg, .png, .pdf"
                multiple={false}

                note="Only PDF, JPG, JPEG, and PNG files are allowed."
              />

            </div>

            {formData.gst_type === 'ELIGIBLE'
              && <div className='TextInputRow'>
                <TextInput
                  label="GST Number"
                  name="gst_no"
                  required={true}
                  value={formData.gst_no}
                  onChange={(e) => handleChange(e, 'gst_no')}
                  placeholder="Enter GST Number"
                  fieldType="gstNumber"
                  caseType={'uppercase'}
                  error={formErrors.gst_no}
                />
                <FileUpload
                  label="Upload GST Document"
                  onChange={(e) => handleFileChange(e, 'upload_gst_certificate')}
                  value={details.url_upload_gst_certificate || ""}
                  required={true}
                  accept=".jpg, .jpeg, .png, .pdf"
                  multiple={false}
                  note="Only PDF, JPG, JPEG, and PNG files are allowed."
                />


              </div>}


            <div className='TextInputRow'>

              <FileUpload
                label="Upload AOA Document"
                onChange={(e) => handleFileChange(e, 'upload_aoa_form')}
                value={details.url_upload_aoa_form || ""}
                required={false}
                accept=".jpg, .jpeg, .png, .pdf"
                multiple={false}
                error={formErrors.upload_aoa_form}

                note="Only PDF, JPG, JPEG, and PNG files are allowed."
              />
              <FileUpload
                label="Upload MOA Document"
                onChange={(e) => handleFileChange(e, 'upload_moa_form')}
                value={details.url_upload_moa_form || ""}
                required={false}
                accept=".jpg, .jpeg, .png, .pdf"
                multiple={false}
                note="Only PDF, JPG, JPEG, and PNG files are allowed."
                error={formErrors.upload_moa_form}

              />


            </div>



          </div>

          <div className='details-bifurcation-card'>
            <h3>Comments/Remarks (Optional)</h3>
            <div className='TextInputRow'>
              <div className='remarks-container' style={{ width: '100%' }}>
                <label className="input-label">Comments/Remarks (Optional)</label>
                {comments.length < 2 && (
                  <div className="comment-form">
                    <input
                      type="text"
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      className="comment-input"
                      placeholder="Description"
                    />
                    <button
                      type="button"
                      onClick={handleAddComment}
                      className="add-button"
                    >
                      ADD
                    </button>
                  </div>
                )}

                {/* Display existing comments */}
                <div className="comments-container">
                  {comments.map(comment => (
                    <div
                      key={comment.id}
                      className="comment-item"
                    >
                      <input
                        type="text"
                        value={comment.text}
                        readOnly
                        className="comment-text"
                      />
                      <button
                        type="button"
                        onClick={() => handleRemoveComment(comment.id)}
                        className="remove-button"
                      >
                        REMOVE
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className='SubmitButton'>
            <button
              type="button"
              className='Saved-Data-button'
              onClick={handleSaveDraft}
              disabled={isSaving || isSubmitting}
            >
              {isSaving ? 'Saving...' : 'Save Draft'}
            </button>
            <button
              type="submit"
              className="Approved-button"
              disabled={isSaving || isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>


      </div>

    </div>
  );

};
